import { createServerFn } from "@tanstack/react-start";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

export const getSitemapData = createServerFn({ method: "GET" }).handler(async () => {
  const { data, error } = await supabaseAdmin
    .from("seo_pages")
    .select("segment, city_slug, city_name")
    .eq("is_published", true)
    .order("city_name");
  if (error) throw new Error(error.message);
  return { pages: data ?? [] };
});
